import { Sidebar } from '@/components/layout/Sidebar';
import { useLanguage } from '@/hooks/useLanguage';

/**
 * Placeholder until the dedicated Users surface ships. We still
 * render the Sidebar so the user can navigate away — without it,
 * landing on /<tenant>/admin/users leaves them stranded with no
 * way back except the browser's back button.
 */
export default function AdminUsersPage() {
  const { t } = useLanguage();
  return (
    <div className="admin-container">
      <Sidebar />
      <div className="main-container">
        <main className="main-content" style={{ padding: '48px' }}>
          <h1>{t('admin.adminUsersComingSoon')}</h1>
        </main>
      </div>
    </div>
  );
}
